import { useParams } from "react-router-dom";
import { s2InboundEmailId } from "../util/type-conversion";

/**
 * @returns {import("@seabrookstudios/pitch2table-core").InboundEmailId}
 */
export const useInboxMessageIdFromRoute = () => {
  return s2InboundEmailId(useParams().messageId || "");
};
